import { render, staticRenderFns } from "./CadastrosDeferidos.vue?vue&type=template&id=e7a96cc6&scoped=true"
import script from "./CadastrosDeferidos.vue?vue&type=script&lang=js"
export * from "./CadastrosDeferidos.vue?vue&type=script&lang=js"
import style0 from "./CadastrosDeferidos.vue?vue&type=style&index=0&id=e7a96cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a96cc6",
  null
  
)

export default component.exports